import axios from "axios";
import { decorateApiError } from "../utils/apiErrorUtils";

const instance = axios.create({
  // baseURL: "https://seeragro.vyakhyan.com/plambo/api/v1", // java api
  // baseURL: "http://192.168.1.7:2025/api/v1" // ip for testing
  // baseURL:"https://pbp.morningwalkusa.com/plambo/api/v1"    //new server ip
  baseURL: process.env.REACT_APP_DOMAIN + "/plambo/api/v1"
    // baseURL:"https://pbp.morningwalkusa.com/plambo/api/v1"    //new server ip production
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  } 
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(decorateApiError(error)),
);

export default instance;
